import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_text = _resolveComponent("ap-text")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_ap_tsla = _resolveComponent("ap-tsla")!
  const _component_ap_tcomment_history = _resolveComponent("ap-tcomment-history")!
  const _component_travel_text = _resolveComponent("travel-text")!
  const _component_travel_tsla = _resolveComponent("travel-tsla")!
  const _component_pc_text = _resolveComponent("pc-text")!
  const _component_pc_tsla = _resolveComponent("pc-tsla")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: _ctx.name }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tabs, { style: {"text-align":"left"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, {
            key: "1",
            tab: "AP_T_EXT"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ap_text)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "AP_T_SLA"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ap_tsla)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "3",
            tab: "AP_T_COMMENT_HISTORY"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ap_tcomment_history)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "4",
            tab: "Travel_T_EXT"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_travel_text)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "5",
            tab: "Travel_T_SLA"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_travel_tsla)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "6",
            tab: "PC_T_EXT"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_pc_text)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "7",
            tab: "PC_T_SLA"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_pc_tsla)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}